var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "v-card",
    { attrs: { flat: _vm.flat } },
    [
      _c(
        "v-card-title",
        {
          staticClass: "d-flex align-center",
          class: _vm.isMobile ? "justify-center" : ""
        },
        [
          _vm.createButton
            ? _c(
                "v-btn",
                {
                  staticClass: "custom-button",
                  attrs: {
                    type: "button",
                    color: "accent",
                    disabled: _vm.fetching
                  },
                  on: {
                    click: function($event) {
                      return _vm.$emit("create")
                    }
                  }
                },
                [
                  _vm._v(
                    "\n            " +
                      _vm._s(_vm.createButtonLabel) +
                      "\n        "
                  )
                ]
              )
            : _vm._e(),
          _vm._v(" "),
          !_vm.isMobile ? _c("v-spacer") : _vm._e(),
          _vm._v(" "),
          _vm._t("additional-buttons"),
          _vm._v(" "),
          _vm.downloadButton
            ? _c(
                "v-tooltip",
                {
                  attrs: { bottom: "" },
                  scopedSlots: _vm._u(
                    [
                      {
                        key: "activator",
                        fn: function(ref) {
                          var on = ref.on
                          return [
                            _c(
                              "v-btn",
                              _vm._g(
                                {
                                  attrs: { icon: "", disabled: _vm.fetching },
                                  on: {
                                    click: function($event) {
                                      return _vm.$emit("download")
                                    }
                                  }
                                },
                                on
                              ),
                              [_c("v-icon", [_vm._v("$mdiDownload")])],
                              1
                            )
                          ]
                        }
                      }
                    ],
                    null,
                    false,
                    4129953446
                  )
                },
                [_vm._v(" "), _c("span", [_vm._v("Download")])]
              )
            : _vm._e(),
          _vm._v(" "),
          _c(
            "v-tooltip",
            {
              attrs: { bottom: "" },
              scopedSlots: _vm._u([
                {
                  key: "activator",
                  fn: function(ref) {
                    var on = ref.on
                    return [
                      _c(
                        "v-btn",
                        _vm._g(
                          {
                            attrs: { icon: "", disabled: _vm.fetching },
                            on: { click: _vm.fetchData }
                          },
                          on
                        ),
                        [_c("v-icon", [_vm._v("$mdiAutorenew")])],
                        1
                      )
                    ]
                  }
                }
              ])
            },
            [_vm._v(" "), _c("span", [_vm._v("Refresh")])]
          ),
          _vm._v(" "),
          _c(
            "v-tooltip",
            {
              attrs: { bottom: "" },
              scopedSlots: _vm._u([
                {
                  key: "activator",
                  fn: function(ref) {
                    var on = ref.on
                    return [
                      _c(
                        "v-btn",
                        {
                          directives: [
                            {
                              name: "show",
                              rawName: "v-show",
                              value: _vm.showFiltersBadge,
                              expression: "showFiltersBadge"
                            }
                          ],
                          attrs: { icon: "", disabled: _vm.fetching },
                          nativeOn: {
                            click: function($event) {
                              $event.stopPropagation()
                              return _vm.resetFilters($event)
                            }
                          }
                        },
                        [
                          _c("v-icon", [
                            _vm._v(
                              "\n                        $mdiFilterRemoveOutline\n                    "
                            )
                          ])
                        ],
                        1
                      )
                    ]
                  }
                }
              ])
            },
            [_vm._v(" "), _c("span", [_vm._v("Clear Filters")])]
          ),
          _vm._v(" "),
          _vm.filterButton
            ? _c(
                "v-tooltip",
                {
                  attrs: { bottom: "" },
                  scopedSlots: _vm._u(
                    [
                      {
                        key: "activator",
                        fn: function(ref) {
                          var on = ref.on
                          return [
                            _c(
                              "v-btn",
                              _vm._g(
                                {
                                  attrs: { icon: "", disabled: _vm.fetching },
                                  nativeOn: {
                                    click: function($event) {
                                      $event.stopPropagation()
                                      return _vm.toggleFilterDrawer($event)
                                    }
                                  }
                                },
                                on
                              ),
                              [
                                _c(
                                  "v-badge",
                                  {
                                    attrs: {
                                      value: _vm.showFiltersBadge,
                                      color: "error",
                                      left: "",
                                      overlap: ""
                                    }
                                  },
                                  [
                                    _c(
                                      "span",
                                      {
                                        attrs: { slot: "badge" },
                                        slot: "badge"
                                      },
                                      [
                                        _vm._v(
                                          "\n                            " +
                                            _vm._s(_vm.selectedFiltersCount) +
                                            "\n                        "
                                        )
                                      ]
                                    ),
                                    _vm._v(" "),
                                    _c("v-icon", [_vm._v("$mdiFilterVariant")])
                                  ],
                                  1
                                )
                              ],
                              1
                            )
                          ]
                        }
                      }
                    ],
                    null,
                    false,
                    3693577446
                  )
                },
                [_vm._v(" "), _c("span", [_vm._v("Filters")])]
              )
            : _vm._e(),
          _vm._v(" "),
          _c("v-text-field", {
            staticClass: "title-branding custom-input ml-3",
            class: _vm.isMobile ? "mt-2" : "",
            attrs: {
              label: "Search",
              type: "text",
              filled: "",
              "hide-details": "",
              "prepend-inner-icon": "$mdiMagnify",
              disabled: _vm.fetching
            },
            model: {
              value: _vm.searchQuery,
              callback: function($$v) {
                _vm.searchQuery = $$v
              },
              expression: "searchQuery"
            }
          })
        ],
        2
      ),
      _vm._v(" "),
      _c(
        "v-card-text",
        [
          _c("v-data-table", {
            attrs: {
              headers: _vm.headers,
              items: _vm.items,
              options: _vm.options,
              "server-items-length": _vm.totalItems,
              loading: _vm.fetching,
              "footer-props": {
                "items-per-page-options":
                  _vm.$store.getters["application/getPerPage"],
                "disable-items-per-page": _vm.freeze,
                "disable-pagination": _vm.freeze
              },
              "multi-sort": "",
              "disable-filtering": _vm.freeze,
              "disable-pagination": _vm.freeze,
              "disable-sort": _vm.freeze,
              "mobile-breakpoint": _vm.breakpoint
            },
            on: {
              "update:options": function($event) {
                _vm.options = $event
              }
            },
            scopedSlots: _vm._u(
              [
                {
                  key: "body",
                  fn: function(ref) {
                    var items = ref.items
                    var isMobile = ref.isMobile
                    return [
                      _c(
                        "tbody",
                        _vm._l(items, function(item, index) {
                          return _c(
                            "tr",
                            {
                              key: index,
                              class: [
                                isMobile
                                  ? "v-data-table__mobile-table-row"
                                  : "",
                                _vm.clickable ? "pointer" : "",
                                _vm.customClasses(item)
                              ],
                              on: {
                                click: function($event) {
                                  return _vm.triggerClickEvent(item)
                                }
                              }
                            },
                            [
                              isMobile
                                ? [
                                    _vm._t(
                                      "card",
                                      _vm._l(_vm.headers, function(
                                        header,
                                        headerIndex
                                      ) {
                                        return _c(
                                          "td",
                                          {
                                            key: headerIndex,
                                            staticClass:
                                              "v-data-table__mobile-row"
                                          },
                                          [
                                            _c(
                                              "div",
                                              {
                                                staticClass:
                                                  "v-data-table__mobile-row__header"
                                              },
                                              [
                                                _vm._v(
                                                  "\n                                    " +
                                                    _vm._s(header.text) +
                                                    "\n                                "
                                                )
                                              ]
                                            ),
                                            _vm._v(" "),
                                            _c(
                                              "div",
                                              {
                                                staticClass:
                                                  "v-data-table__mobile-row__cell"
                                              },
                                              [
                                                _vm._v(
                                                  "\n                                    " +
                                                    _vm._s(
                                                      _vm.getCardValue(
                                                        item,
                                                        header.value
                                                      )
                                                    ) +
                                                    "\n                                "
                                                )
                                              ]
                                            )
                                          ]
                                        )
                                      }),
                                      { item: item }
                                    )
                                  ]
                                : [_vm._t("row", null, { item: item })]
                            ],
                            2
                          )
                        }),
                        0
                      )
                    ]
                  }
                }
              ],
              null,
              true
            )
          })
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }